import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const KEY = 'am.prefs';
const DEFAULTS = { units: 'metric', toasts: true, tourSeen: false, refresh: 15 };
const PrefsContext = createContext(null);
export const usePrefs = () => useContext(PrefsContext);

const read = () => {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch (e) { return DEFAULTS; }
};

export function PrefsProvider({ children }) {
  const [prefs, setPrefs] = useState(read);
  const set = useCallback((patch) => {
    setPrefs((p) => {
      const n = { ...p, ...patch };
      try { localStorage.setItem(KEY, JSON.stringify(n)); } catch (e) { /* storage may be blocked */ }
      return n;
    });
  }, []);
  const value = useMemo(() => ({ ...prefs, set }), [prefs, set]);
  return <PrefsContext.Provider value={value}>{children}</PrefsContext.Provider>;
}
